import React from "react";
import { CBadge } from "@coreui/react";
import { getExecutionStatusMeta } from "@src/utils/executionStatus";
import { formatDateTimeShort } from "@src/utils/dateUtils";

interface Props {
  statusName?: string | null;
  suspendCauseName?: "infra" | "safety" | null;
  recoveryNotBeforeTs?: string | null;
}

/**
 * Renders an execution's real lifecycle status as a colored badge with a contextual hint: a
 * suspended row shows when it auto-resumes; a halted row reads as repair-required. Legacy rows with
 * no status_name fall back to "Running" (the pre-resume-system behavior).
 */
export const ExecutionStatusBadge: React.FC<Props> = ({
  statusName,
  suspendCauseName,
  recoveryNotBeforeTs,
}) => {
  const status = statusName || "running";
  const meta = getExecutionStatusMeta(status);

  return (
    <span className="ExecutionStatusBadge">
      <CBadge color={meta.color} size="sm">
        {meta.label}
      </CBadge>
      {status === "suspended" && (
        <span className="ExecutionStatusBadge-hint text-muted ms-1">
          {recoveryNotBeforeTs
            ? `auto-resumes at ${formatDateTimeShort(recoveryNotBeforeTs)}`
            : suspendCauseName === "infra"
              ? "auto-resumes when infra recovers"
              : "auto-resumes"}
        </span>
      )}
      {status === "halted" && (
        <span className="ExecutionStatusBadge-hint text-danger ms-1">repair required</span>
      )}
    </span>
  );
};
